import React, { useState } from "react";
import { ApiHook } from "../../hooks/apiHook";
import { BASE_URL, DEFAULT_KEY } from "../../config/config";
import "./payment-details.css";
import TableMain from "../../components/Common/table/TableMain";

const PaymentDetails = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const { data, isLoading, isError } = ApiHook.CallPaymentReport();


  if (isLoading) return <div>Loading...</div>;
  if (isError || !data || !data.data) return <div>Failed to fetch payment details</div>;

  const payments = data?.data?.payments || [];
  const totalPages = data.data.pagination.totalPages || 1;

  const headers = ["PaymentDate", "paymentAmount", "paymentMethod","paymentStatus", "transactionId" ,"failureReason","type"];

  return (
    <div className="payment-details-container">
      <div className="page_head_top">{("Payment Details")}</div>
      <div className="table-responsive min-hieght-table">
        <TableMain
          headers={headers}
          data={payments}
          startPage={1}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={() => {}}
          type={"payment-details"}
        />
      </div>
    </div>
  );
};

export default PaymentDetails;
